import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import * as SharedModels from '@shared-models/index';
import {Params} from '@angular/router';

export const noOverlayClass = 'no-overlay';

export enum CountryEnum {
    US = 'US',
    USI = 'USI'
}

export interface KeyValue {
    [key: string]: any;
}

export interface DateRangePickerOutput {
    dateRange: Array<string>;
    columnName: string;
    sortOrder?: string;
    sortOrderName?: string;
}


export interface NavigationItem {
    routerLink: string;
    itemName: string;
    availableForRoles: SharedModels.CE.UserRoleEnum[];
    queryParams?: Params;
    children?: NavigationItem[];
    isOpened?: boolean;
    childrenRouterLinks?: string[];
}

export interface PhotoData {
    uId: string;
    name?: string;
    contentType?: string;
    length?: number;
    dataImage?: string;
    url?: string;
}

export interface IUploadUrlRequest {
    name: string;
    contentType: string;
    length: number;
}

export interface IUploadUrlResponse {
    uId: string;
    url: string;
    headersToSet: {[key: string]: string};
}

export interface IPhotoUpload {
    uploadPhoto(request: IUploadUrlRequest, uploadUrl: string, dataUrl: string): Observable<PhotoData>;
}

export interface IFileUpload {
    uploadFile(file: File, uploadUrl?: string): Observable<PhotoData>;
}

export interface IFileDelete {
    deleteFile(uId: string): Observable<null>;
}

export const UPLOAD_URL = new InjectionToken<string>('Upload url token');
export const UPLOAD_ATTACHMENT_URL = new InjectionToken<string>('Upload url token');
export const UPLOAD_VISITOR_URL = new InjectionToken<string>('Upload url token');

export const DELETE_URL = new InjectionToken<string>('Delete file url token');
export const GET_DOWNLOAD_URL = new InjectionToken<string>('Get download url token');
export const DOWNLOAD_ATTACHMENT_URL = new InjectionToken<string>('Get download url token');
export const GET_VISITOR_DOWNLOAD_URL = new InjectionToken<string>('Get download url token');
export const GET_ATTACHMENT_DOWNLOAD_URL = new InjectionToken<string>('Get download url token');
export const GET_ATTACHMENT_UPLOAD_URL = new InjectionToken<string>('Get download url token');

export const GET_DOWNLOAD_ND_TEMPLATE = new InjectionToken<string>('Get download url token');
export const GET_DOWNLOAD_MF_TEMPLATE = new InjectionToken<string>('Get download url token');
export const GET_DOWNLOAD_3RDPTY_TEMPLATE = new InjectionToken<string>('Get download url token');
export const GET_DOWNLOAD_CLE_TEMPLATE = new InjectionToken<string>('Get download url token');
export const GET_DOWNLOAD_CLE_EXT_TEMPLATE = new InjectionToken<string>('Get download url token');

export const GET_UPLOAD_ND_TEMPLATE = new InjectionToken<string>('Get download url token');
export const GET_UPLOAD_MF_TEMPLATE = new InjectionToken<string>('Get download url token');
export const GET_UPLOAD_3RDPTY_TEMPLATE = new InjectionToken<string>('Get download url token');
export const GET_UPLOAD_CLE_TEMPLATE = new InjectionToken<string>('Get download url token');


export const API_CONFIG = new InjectionToken<string>('Api config');

export const DOWNLOAD_BULK_ND_TEMPLATE = new InjectionToken<string>('Get download url token');
export const DOWNLOAD_BULK_MF_TEMPLATE = new InjectionToken<string>('Get download url token');
export const DOWNLOAD_BULK_TRDPTY_TEMPLATE = new InjectionToken<string>('Get download url token');

export const UPLOAD_BULK_ND_TEMPLATE = new InjectionToken<string>('Get upload url token');
export const UPLOAD_BULK_MF_TEMPLATE = new InjectionToken<string>('Get upload url token');
export const UPLOAD_BULK_TRDPTY_TEMPLATE = new InjectionToken<string>('Get upload url token');


export interface IFileInfo extends Pick<File, 'name' | 'type' | 'size'> {
    uId?: string;
    dataImage?: string; // base64 string
}

export interface ImageDimensions {
    width: number;
    height: number;
}

export interface RecommendedDimensions extends ImageDimensions {
    value: string;
    isImage: boolean;
    minWidth?: number;
    maxWidth?: number;
    minHeight?: number;
    maxHeight?: number;
}

//// UserData
export interface IUserData {
    userId: number;
    email: string;
    country: string;
    firstName: string;
    lastName: string;
    initials: string;
    fullName: string;
    userRoleId: number;
    userRoleIds?: number[];
    userRoleName: string;
    photoUrl: string;
    alias: string;
    employeeGroupDesc: string;
    isUSI?: boolean;
    isSeniorManagerAndAbove: boolean;
    isPPMDPrimaryAdmin  : boolean;
}

//// EmployeeRoleModel
export interface IEmployeeRoleModel {
    roleId: number;
    roleName: string;
}


//// PhotoReviewModel
export interface IPhotoReviewModel {
    userId: number;
    roleId: number;
    photoGuid: string;
    fullEmployeeName: string;
    roleCategoryId: number;
    roleCategoryName: string;
    siteId: number;
    siteName: string;
    badgeRequestStatusId: number;
    badgeRequestStatusName: string;
    photoRequestStatusId: number;
    photoRequestStatusName: string;
    requestedDate: Date | string;
    startDate: Date | string;
}

export interface LogoNavigation {
    url: string;
    queryParams: Params;
}

export const ErrorBlackListToken = new InjectionToken<string>('http errors blacklist token');

export interface ErrorBlackListModel {
    status: number;
    url: string;
}

export interface FileUploadModel {
    action: number;
    data: IFileInfo[];
}

export interface IMultiDropdownOption {
    id: number | string;
    value: string;
    checked: boolean;
}

export interface IDetectFacesDto {
    settings: {
        isImageRecognitionEnabled: boolean;
        boxingPercentage: number;
    };
    boundingBox: {
        height: number;
        left: number;
        top: number;
        width: number;
    };
}

export interface ICroppingSettings {
    isImageRecognitionEnabled: boolean;
    boxingPercentage: number;
    minPhotoSizePx: {
        width: number;
        height: number;
    };
}

export interface ICroppPhotoRequestOld {
    uId: string;
    badgeRequestId: number;
    croppInfo: string;
    isAutocropped: boolean;
}

export interface IAllCropperData {
    data: {
        x: number;
        y: number;
        width: number;
        height: number;
        rotate: number;
        scaleX: number;
        scaleY: number;
    };
    cropBoxData: {
        left: number;
        top: number;
        width: number;
        height: number;
    };
    canvasData: {
        left: number;
        top: number;
        width: number;
        height: number;
        naturalWidth: number;
        naturalHeight: number;
    };
}

export interface IDownloadUrlResponse {
    name: string;
    contentType: string;
    length: number;
    url: string;
}


export enum BadgeRequestCategoryEnum {
    PreHire = 1,
    Employee = 2,
    ThirdPartyContractor = 3,
    MemberFirm = 4,
    NonDeloitte = 5,
    FullTimeEmployee = 6,
    ContractorsOrInterns = 7,
    CleContractor = 8,
    MdfWorkPermit = 9,
    IdfWorkPermit = 10
}

export interface IParserResponse<IT> {
    data: Array<IT>;
    successfullyParsedCount: number;
    nonSuccessfullyParsedCount: number;
}
